import {
  Navigate,
  Outlet,
  createRootRoute,
  useLocation,
} from "@tanstack/react-router";
import { SessionLoadingScreen } from "@/components/common/SessionLoadingScreen";
import { useAdminAuth } from "@/providers/AdminAuthProvider";
import { ROUTES } from "@/lib/constants/routes";

export const Route = createRootRoute({
  component: RootRoute,
});

function RootRoute() {
  const { state, loginRedirectReason } = useAdminAuth();
  const { pathname } = useLocation();
  const onLoginPage = pathname === ROUTES.login;

  // TEMP (testing only): visiting any page with `?splash` in the URL pins the
  // session-loading screen on screen so it can be reviewed. Remove this block
  // when done. e.g. http://localhost:3001/?splash
  const forceSplash =
    typeof window !== "undefined" &&
    new URLSearchParams(window.location.search).has("splash");
  if (forceSplash) {
    return <SessionLoadingScreen label="Checking session" />;
  }

  if (state.status === "loading") {
    return <SessionLoadingScreen label="Checking session" />;
  }

  if (state.status === "authenticated" && onLoginPage) {
    return <Navigate to={ROUTES.overview} replace />;
  }

  if (state.status === "unauthenticated" && !onLoginPage) {
    return (
      <Navigate to={ROUTES.login} search={{ reason: loginRedirectReason }} replace />
    );
  }

  return (
    <>
      <Outlet />
    </>
  );
}
